import { render, staticRenderFns } from "./NewCardDialog.vue?vue&type=template&id=e6e5f852&scoped=true&"
import script from "./NewCardDialog.vue?vue&type=script&lang=js&"
export * from "./NewCardDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewCardDialog.vue?vue&type=style&index=0&id=e6e5f852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e5f852",
  null
  
)

export default component.exports